import React, { FC } from "react";
import FeatherIcon from "feather-icons-react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import { useGetCsobDatasetComparison } from "@api";
import { Box, Button, Typography, Alert, Grid } from "@components/base";
import { CsobRegimeType, useUserStore } from "@store/user";

const InfoBanner: FC = () => {
  const navigate = useNavigate();
  const { user, jwtTokenData } = useUserStore();
  const {
    csobDatasetComparison,
    csobDatasetComparisonEnabled,
    isLoadingGetCsobDatasetComparison,
  } = useGetCsobDatasetComparison(
    user,
    jwtTokenData?.csobRegimeType === CsobRegimeType.Closed,
  );

  if (
    isLoadingGetCsobDatasetComparison ||
    !csobDatasetComparisonEnabled ||
    !csobDatasetComparison ||
    !csobDatasetComparison.displayDatasetBanner
  ) {
    return null;
  }

  return (
    <Grid size={12}>
      <Alert
        color="info"
        icon={
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <FeatherIcon icon="info" size={20} />
            <Typography fontSize={14}>
              {t("csob.hub.infoBanner.description")}
            </Typography>
          </Box>
        }
        sx={{ alignItems: "center", justifyContent: "space-between" }}
      >
        <Box>
          <Button
            variant="outlined"
            size="small"
            color="info"
            onClick={() => navigate("/csob/dataset-comparison")}
          >
            {t("csob.hub.infoBanner.buttonDataset")}
          </Button>
        </Box>
      </Alert>
    </Grid>
  );
};

export default InfoBanner;
